import {
    GET_PURCHASE_ORDER_HISTORY,
    SET_PURCHASE_ORDER_HISTORY
} from './FleetPurchaseOrderHistoryType'

const getFleetPurchaseOrderHistory = (payload : any) =>({
    type : GET_PURCHASE_ORDER_HISTORY,
    payload
})

const setFleetPurchaseOrderHistory = (fleetPurchaseOrderHistory : any) =>({
    type : SET_PURCHASE_ORDER_HISTORY,
    fleetPurchaseOrderHistory : fleetPurchaseOrderHistory
})

export {
    getFleetPurchaseOrderHistory,
    setFleetPurchaseOrderHistory
}